export interface FeatureItem {
  id: number;
  tag: string;
  title: string;
  minutes: string;
  excerpt: string;
  meta: string;
  image: string;
}

export const featureItems: FeatureItem[] = [
  {
    id: 1,
    tag: '深度专题',
    title: '一个热点事件是怎么"爆"起来的：吃瓜传播全链路拆解',
    minutes: '8 分钟阅读',
    excerpt:
      '从一条小范围截图，到登上全网热榜，往往只需要几个小时。本期拆解热点事件从发酵、接力到反转的完整路径，看懂"料"到底是怎么一步步被追到滚烫的。',
    meta: '事件脉络 · 传播观察',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20spreading%20signal%20wave%20from%20a%20single%20light%20bulb%20radiating%20to%20many%20nodes%20and%20screens%2C%20concept%20of%20viral%20information%20flow%2C%20tangerine%20coral%20and%20amber%20tone%20palette%20on%20soft%20cream%20background%2C%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20and%20airy%20composition%20with%20rounded%20shapes&width=1200&height=800&seq=feature-flow&orientation=landscape',
  },
  {
    id: 2,
    tag: '栏目指南',
    title: '看料站频道怎么逛：一份帮你不错过关键节点的速报地图',
    minutes: '5 分钟阅读',
    excerpt:
      '娱乐、影视、综艺、社会、资讯、热梗……六大频道分别追踪什么？哪些信号代表事件正在快速升温？这篇指南教你用最快的速度锁定当天真正值得关注的料。',
    meta: '使用指南 · 频道导航',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20navigation%20map%20compass%20and%20route%20points%20connecting%20different%20channel%20cards%2C%20coral%20orange%20and%20golden%20tone%20palette%20on%20soft%20cream%20background%2C%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20and%20airy%20composition%20with%20rounded%20shapes&width=1200&height=800&seq=feature-map&orientation=landscape',
  },
  {
    id: 3,
    tag: '现象观察',
    title: '「看瓜」为什么让人停不下来？围观文化背后的心理机制',
    minutes: '6 分钟阅读',
    excerpt:
      '为什么热点总像有引力，让人忍不住刷新？从悬念追踪到群体共情，透过围观文化聊聊我们愿意追更、乐于吃瓜的心理动因，以及如何更理性地看待每一次热搜。',
    meta: '心理观察 · 内容思辨',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20curious%20crowd%20peeking%20at%20a%20glowing%20spotlight%20event%20through%20magnifying%20glasses%2C%20concept%20of%20curiosity%20and%20bystander%20attention%2C%20terracotta%20orange%20and%20peach%20tone%20palette%20on%20soft%20cream%20background%2C%20flat%20vector%20style%20with%20subtle%20grain%2C%20clean%20and%20airy%20composition%20with%20rounded%20shapes&width=1200&height=800&seq=feature-psycho&orientation=landscape',
  },
];